import React from 'react';
import { motion } from 'framer-motion';
import nigeria from "../assets/images/nigerian-logo.png";
import uganda from "../assets/images/uganda.png";
import kenya from "../assets/images/kenya.png";
import cameroon from "../assets/images/cameroon.png";
import canada from "../assets/images/canada.png";
import uae from "../assets/images/uae.png";

export default function PopularCountry() {
    return (
        <section className='py-[5%] px-[8%]'>
            <div className='grid lg:grid-cols-2 gap-12 px-8'>
                {/* Text Section with Slide-in Animation */}
                <motion.div
                    initial={{ x: -100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ type: 'spring', stiffness: 100, damping: 25 }}
                >
                    <h3 className='pt-6 text-[1.6rem] font-[800] leading-[1.3]'>
                        Popular Countries <br />We <span className='relative text-[var(--second-primary-color)] popular_countries'>Send Money</span>
                    </h3>
                </motion.div>

                {/* Country Logos with Staggered Animation */}
                <motion.div
                    className='grid grid-cols-3 gap-4 uppercase text-[.8rem] font-[600] text-[#555D68]'
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1, staggerChildren: 0.3 }} // Stagger animation for each child
                >
                    {/* Country Items */}
                    {[{src: nigeria, country: "NGN"}, {src: uganda, country: "uganda"}, {src: kenya, country: "kenya"},
                    {src: cameroon, country: "cameroon"}, {src: canada, country: "canada"}, {src: uae, country: "uae"}].map((item, index) => (
                        <motion.div
                            key={index}
                            className='flex px-2'
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.2, duration: 0.5 }}
                        >
                            <img className='w-[20px] h-[20px]' src={item.src} alt={`${item.country} logo`} />
                            <span className='px-2'>{item.country}</span>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    )
}
